import React from "react";

const CalculatorIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 24 28"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {/* body */}
    <rect x="4" y="2" width="16" height="22" rx="2" />

    {/* display */}
    <rect x="7" y="4.5" width="10" height="4" />

    {/* buttons */}
    <circle cx="8" cy="12" r="1" />
    <circle cx="12" cy="12" r="1" />
    <circle cx="16" cy="12" r="1" />

    <circle cx="8" cy="15.5" r="1" />
    <circle cx="12" cy="15.5" r="1" />
    <circle cx="16" cy="15.5" r="1" />

    <circle cx="8" cy="19" r="1" />
    <circle cx="12" cy="19" r="1" />
    <circle cx="16" cy="19" r="1" />
  </svg>
);

export default CalculatorIcon;
